export const submodelModels = {
    id: "submodel",
    name: "submodel",
    api: "https://llm.submodel.ai/v1",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://submodel.gitbook.io",
    env: ["SUBMODEL_INSTAGEN_ACCESS_KEY"],
    models: {
        "deepseek-ai/DeepSeek-V3.1": {
            id: "deepseek-ai/DeepSeek-V3.1",
            name: "DeepSeek V3.1",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-23",
            last_updated: "2025-08-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.2,
                output: 0.8,
            },
            limit: {
                context: 75000,
                output: 163840,
            },
        },
        "deepseek-ai/DeepSeek-V3-0324": {
            id: "deepseek-ai/DeepSeek-V3-0324",
            name: "DeepSeek V3 0324",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-23",
            last_updated: "2025-08-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.2,
                output: 0.8,
            },
            limit: {
                context: 75000,
                output: 163840,
            },
        },
        "deepseek-ai/DeepSeek-R1-0528": {
            id: "deepseek-ai/DeepSeek-R1-0528",
            name: "DeepSeek R1 0528",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-23",
            last_updated: "2025-08-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.5,
                output: 2.15,
            },
            limit: {
                context: 75000,
                output: 163840,
            },
        },
        "openai/gpt-oss-120b": {
            id: "openai/gpt-oss-120b",
            name: "GPT OSS 120B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-23",
            last_updated: "2025-08-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.5,
            },
            limit: {
                context: 131072,
                output: 32768,
            },
        },
        "Qwen/Qwen3-235B-A22B-Thinking-2507": {
            id: "Qwen/Qwen3-235B-A22B-Thinking-2507",
            name: "Qwen3 235B A22B Thinking 2507",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-23",
            last_updated: "2025-08-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 0.6,
            },
            limit: {
                context: 262144,
                output: 131072,
            },
        },
        "Qwen/Qwen3-235B-A22B-Instruct-2507": {
            id: "Qwen/Qwen3-235B-A22B-Instruct-2507",
            name: "Qwen3 235B A22B Instruct 2507",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-23",
            last_updated: "2025-08-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 0.3,
            },
            limit: {
                context: 262144,
                output: 131072,
            },
        },
        "Qwen/Qwen3-Coder-480B-A35B-Instruct-FP8": {
            id: "Qwen/Qwen3-Coder-480B-A35B-Instruct-FP8",
            name: "Qwen3 Coder 480B A35B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-23",
            last_updated: "2025-08-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.2,
                output: 0.8,
            },
            limit: {
                context: 262144,
                output: 262144,
            },
        },
        "zai-org/GLM-4.5-FP8": {
            id: "zai-org/GLM-4.5-FP8",
            name: "GLM 4.5 FP8",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-07-28",
            last_updated: "2025-07-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 0.8,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "zai-org/GLM-4.5-Air": {
            id: "zai-org/GLM-4.5-Air",
            name: "GLM 4.5 Air",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-07-28",
            last_updated: "2025-07-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.5,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
    },
};
export default submodelModels;
//# sourceMappingURL=submodel.js.map